import { styled, Theme } from '@mui/material'
import {
  dialogStyles as baseDialogStyles,
  dialogTitleStyles as baseTitleStyles,
  dialogContentStyles as baseContentStyles,
  inputStyles,
  disabledInputStyles,
} from '../../styles/utilities'

/**
 * Dialog styles for CreateDeal component
 * Using centralized utilities with custom overrides
 */
export const dialogStyles = (theme: Theme) => ({
  ...baseDialogStyles(theme, {
    maxWidth: '800px',
    minHeight: '50vh',
    maxHeight: '95vh',
    padding: '30px',
  }),
  color: '#fff',
  '& .MuiDialogContent-root': {
    width: '100%',
    padding: '30px',
  },
  '& .MuiTextField-root': {
    ...inputStyles(theme),
    margin: '10px 0',
  },
  '& .MuiInputBase-root': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgb(79, 84, 94)' : 'white',
    minWidth: '100%',
  },
  '& .MuiFormControl-root': {
    width: '100%',
  },
  '& .MuiDateRangePicker-root': {
    width: '100%',
  },
})

export const dialogTitleStyles = (theme: Theme) => ({
  ...baseTitleStyles(theme),
  textAlign: 'center' as const,
})

export const boxStyles = {
  display: 'flex',
  flexDirection: 'row' as const,
  justifyContent: 'space-between',
  alignItems: 'center',
}

export const dialogContentStyles = {
  ...baseContentStyles,
  width: 'auto',
  margin: '0 auto',
  gap: 3,
  padding: '24px',
}

export const disabledTextStyles = (theme: Theme) => ({
  ...disabledInputStyles(theme),
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgb(67, 70, 75, 0.4)' : 'white',
  },
})

export const namePreviewStyles = (theme: Theme) => ({
  color: theme.palette.text.primary,
})

export const DialogIcon = styled('img')({
  width: 50,
  height: 50,
  borderRadius: '50%',
})

export const accordionStyle = (theme: Theme) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(49, 54, 67)' : 'rgba(224, 224, 224, 0.3)',
})

export const accordionDetailStyle = (theme: Theme) => ({
  padding: 2,
  width: '100%',
  borderColor: theme.palette.mode === 'dark' ? 'rgb(49, 54, 67)' : 'rgb(229, 229, 229)',
  backgroundColor: 'transparent',
})

export const accordionSummaryStyle = (theme: Theme) => ({
  border: '1px solid',
  borderColor: theme.palette.mode === 'dark' ? 'rgb(108, 113, 120)' : 'rgba(224, 224, 224, 0.3)',
  color: theme.palette.text.primary,
  borderRadius: '5px',
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(67, 70, 75)' : 'rgb(229, 229, 229)',
})
